/* House of Whiskerton - Shopify theme interactions. Vanilla JS, no deps. */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // cart-fix-20260906 C0 instrumentation: fires a PostHog custom event if PostHog has
  // loaded and consent allows capture (snippets/hw-analytics.liquid boots posthog only
  // after consent; posthog-js array.js queues capture() calls made before init() and
  // they are simply never flushed if consent/init never happens - no network call, no
  // PII). No-ops safely if window.posthog is absent entirely (e.g. this script runs
  // before array.js has executed). Read-only instrumentation - never changes behaviour.
  function hwCapture(event, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(event, props || {});
      }
    } catch (e) {}
  }
  var search = (window.location && window.location.search || "").toLowerCase();
  var paidPath = /(?:\?|&)(utm_medium=paid|utm_source=meta|utm_source=facebook|utm_source=instagram|hw_mode=buy)(?:&|$)/.test(search);
  var captureTestMode = /(?:\?|&)capture_test=1(?:&|$)/.test(search);
  var flagshipCartHref = "/products/custom-pet-portrait";

  function normalizeFlagshipCtas() {
    var isBoxPath = /royal-treatment-box|gift-box/.test(window.location.pathname || "");
    var isGiftCollectionPath = /\/collections\/gifts(?:\/|$)/.test(window.location.pathname || "");
    var isDigitalPath = /digital-royal-portrait|digital-copy-add-on/.test(window.location.pathname || "");
    if (isBoxPath || isGiftCollectionPath || isDigitalPath) return;

    [".nav__cta", "#drawer a.btn.btn--block"].forEach(function (sel) {
      var link = document.querySelector(sel);
      if (link && link.tagName === "A") {
        link.setAttribute("href", flagshipCartHref);
        link.innerHTML = 'Start Your Portrait <span class="arr">→</span>';
      }
    });

    $$("a,button").forEach(function (el) {
      var text = (el.innerText || el.textContent || "").replace(/\s+/g, " ").trim();
      if (!/buy the royal portrait/i.test(text)) return;

      if (el.tagName === "A") {
        var href = el.getAttribute("href") || "";
        if (href.indexOf("/products/custom-pet-portrait") !== -1) {
          el.setAttribute("href", flagshipCartHref);
        } else if (href.indexOf(flagshipCartHref) === -1) {
          return;
        }
      }

      el.innerHTML = 'Start Your Portrait <span class="arr">→</span>';
    });
  }

  function normalizeProductNavAnchors() {
    var path = window.location.pathname || "";
    var isProduct = /^\/products\//.test(path);
    if (!isProduct) return;

    var anchorTarget = /royal-treatment-box/.test(path) ? "#MainBox" : "#product-form";
    var productNames = [];
    if (/\/products\/custom-pet-portrait(?:\/|$)/.test(path)) productNames = ["The Royal Portrait"];
    else if (/\/products\/digital-royal-portrait(?:\/|$)/.test(path)) productNames = ["Buy Digital Portrait"];
    else if (/\/products\/digital-copy-add-on(?:\/|$)/.test(path)) productNames = ["Add Digital Copy"];
    else if (/\/products\/the-royal-treatment-box-personalised-dog-gift-box(?:\/|$)/.test(path)) productNames = ["Buy Gift Box", "Gift Box"];

    if (!productNames.length) return;

    $$("header a, #drawer a").forEach(function (link) {
      var text = (link.innerText || link.textContent || "").replace(/\s+/g, " ").trim();
      if (!productNames.some(function (name) { return text === name; })) return;
      link.setAttribute("href", anchorTarget);
    });
  }

  var MONEY_FORMAT = window.HW_MONEY_FORMAT || "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || MONEY_FORMAT;
    function defaultTo(n, d) { return n == null ? d : n; }
    function thousands(num, precision, thousand, decimal) {
      precision = defaultTo(precision, 2);
      thousand = defaultTo(thousand, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousand);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }
    switch (f.match(placeholderRegex)[1]) {
      case "amount": value = thousands(cents, 2); break;
      case "amount_no_decimals": value = thousands(cents, 0); break;
      case "amount_with_comma_separator": value = thousands(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = thousands(cents, 0, ".", ","); break;
      default: value = thousands(cents, 2);
    }
    return f.replace(placeholderRegex, value);
  }

  $$("[data-year]").forEach(function (el) { el.textContent = new Date().getFullYear(); });
  normalizeFlagshipCtas();
  normalizeProductNavAnchors();
  window.addEventListener("load", normalizeFlagshipCtas);
  window.addEventListener("load", normalizeProductNavAnchors);

  var toast = $("#toast");
  var toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 4200);
  }

  var announce = $("#announce");
  if (announce) {
    if (sessionStorage.getItem("hw_announce") === "closed") announce.style.display = "none";
    var ac = $(".close", announce);
    if (ac) ac.addEventListener("click", function () {
      announce.style.display = "none";
      sessionStorage.setItem("hw_announce", "closed");
    });
    if (paidPath) announce.style.display = "none";
  }

  var burger = $(".burger");
  var drawer = $("#drawer");
  var scrim = $("#scrim");
  var cartDrawer = $("#cartDrawer");
  var cartScrim = $("#cartScrim");
  var cartBody = $("#cartDrawerBody");
  var cartStatus = $("#cartDrawerStatus");
  var cartFooter = $("#cartDrawerFooter");
  var cartSubtotal = $("#cartDrawerSubtotal");
  var cartShipping = $("#cartDrawerShipping");
  var cartDelivery = $("#cartDrawerDelivery");
  var cartCountEls = $$("[data-cart-count]");
  var cartOpenEls = $$("[data-cart-open]");
  var cartCloseEls = $$("[data-cart-close]");
  var cartUpsell = $("#cartDrawerUpsell");
  // cart-fix-20260906 C0: the one gold Secure-checkout button (native form submit -> the
  // hosted checkout) and the express-wallet row (Shop Pay / PayPal / Google Pay, injected
  // by Shopify's own dynamic-checkout script). Both are static markup in header.liquid so
  // querying once here at script-init time is safe (matches every other cart var above).
  var secureCheckoutBtn = $("[data-hw-secure-checkout]");
  var cartExpressWrap = $(".cart-drawer__express");
  var cartPending = false;
  var upsellPending = false;
  var cartLastTrigger = null;
  // cart-fix-20260906: which surface triggered the add-to-cart that is about to open
  // the drawer (buybox = default/main CTA or quick-add, buybar = sticky bar). Read once
  // by hw_cart_drawer_opened, then cleared; icon-open leaves it null -> reported as 'icon'.
  var hwLastAddSource = null;
  // last cart.js payload rendered into the drawer - used by the Secure-checkout tap
  // listener so it can report has_preview/format synchronously with no extra fetch
  // (a fetch started on click would race the native form submit/navigation).
  var hwLastCart = null;
  var hwDrawerOpenedAt = null;
  // cart-add-collision guard (2026-08-14, P0 fix -- CART-LEAK-DIAGNOSIS-2026-08-14.md
  // finding A): timestamp of the most recent add-to-cart CLICK (not just success), so
  // any popup can suppress itself around the moment a real add is happening, not only
  // while the fetch is technically in flight.
  var hwLastAtcAt = 0;
  function hwMarkAtcActivity() { hwLastAtcAt = Date.now(); }
  document.addEventListener("mousedown", function (e) {
    var el = e.target.closest && e.target.closest("button, a, [tabindex]");
    if (el) cartLastTrigger = el;
  }, true);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var el = document.activeElement;
    if (el && el.matches && el.matches("button, a, [tabindex]")) cartLastTrigger = el;
  }, true);
  var HW_FLAGSHIP_PRODUCT_ID = 15510168764756;
  var HW_UPSELL_PRODUCT_ID = 15511963304276;
  var HW_UPSELL_VARIANT_ID = 56116444037460;

  function dockCookieBanner() {
    var mobile = false;
    try {
      mobile = (window.matchMedia && window.matchMedia("(max-width: 860px)").matches) ||
        (window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
    } catch (err) {
      mobile = window.innerWidth <= 860;
    }

    var banner = document.getElementById("shopify-pc__banner") ||
      document.querySelector('[role="alertdialog"][aria-label="Cookie consent"]') ||
      document.querySelector('[aria-label="Cookie consent"]');

    if (!banner || !mobile) {
      document.body.classList.remove("hw-cookie-docked");
      return;
    }

    document.body.classList.add("hw-cookie-docked");
    banner.setAttribute("data-hw-docked", "true");
  }

  dockCookieBanner();
  window.addEventListener("resize", dockCookieBanner);
  window.addEventListener("load", dockCookieBanner);
  setTimeout(dockCookieBanner, 1200);
  if ("MutationObserver" in window) {
    var cookieObserver = new MutationObserver(function () { dockCookieBanner(); });
    cookieObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function syncPageLock() {
    var navOpen = drawer && drawer.classList.contains("open");
    var cartOpen = cartDrawer && cartDrawer.classList.contains("open");
    document.body.style.overflow = (navOpen || cartOpen) ? "hidden" : "";
  }

  function toggleNav(open) {
    if (!drawer) return;
    if (open) toggleCart(false);
    drawer.classList.toggle("open", open);
    if (scrim) scrim.classList.toggle("open", open);
    if (burger) {
      burger.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    }
    syncPageLock();
  }

  function toggleCart(open) {
    if (!cartDrawer || !cartScrim) return;
    var wasOpen = cartDrawer.classList.contains("open");
    if (open) toggleNav(false);
    cartDrawer.classList.toggle("open", open);
    cartScrim.classList.toggle("open", open);
    cartDrawer.setAttribute("aria-hidden", open ? "false" : "true");
    cartOpenEls.forEach(function (el) { el.setAttribute("aria-expanded", open ? "true" : "false"); });
    syncPageLock();
    if (open) {
      hwDrawerOpenedAt = Date.now();
      setTimeout(function () {
        var closeBtn = $(".cart-drawer__close", cartDrawer);
        if (closeBtn) closeBtn.focus();
      }, 60);
    } else {
      if (wasOpen && hwDrawerOpenedAt) {
        hwCapture('hw_cart_drawer_closed', { seconds_open: Math.round((Date.now() - hwDrawerOpenedAt) / 1000) });
      }
      hwDrawerOpenedAt = null;
      if (cartLastTrigger && typeof cartLastTrigger.focus === "function") {
        cartLastTrigger.focus();
        cartLastTrigger = null;
      }
    }
  }

  if (burger) burger.addEventListener("click", function () {
    toggleNav(!drawer.classList.contains("open"));
  });
  if (scrim) scrim.addEventListener("click", function () { toggleNav(false); });
  $$("#drawer a").forEach(function (a) { a.addEventListener("click", function () { toggleNav(false); }); });

  $$(".acc").forEach(function (acc) {
    var q = $(".acc__q", acc);
    var a = $(".acc__a", acc);
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var open = acc.classList.toggle("open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
    });
  });

  $$(".ba").forEach(function (ba) {
    var before = $(".ba__before", ba);
    var handle = $(".ba__handle", ba);
    var dragging = false;
    if (!before || !handle) return;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = ((x - r.left) / r.width) * 100;
      p = Math.max(4, Math.min(96, p));
      before.style.width = p + "%";
      handle.style.left = p + "%";
    }
    function move(e) {
      if (!dragging) return;
      set(e.touches ? e.touches[0].clientX : e.clientX);
    }
    ba.addEventListener("mousedown", function (e) { dragging = true; set(e.clientX); });
    ba.addEventListener("touchstart", function (e) { dragging = true; set(e.touches[0].clientX); }, { passive: true });
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("mouseup", function () { dragging = false; });
    window.addEventListener("touchend", function () { dragging = false; });
  });

  if ("IntersectionObserver" in window) {
    // 2026-08-12 PDP-fix-wave: root cause of the parity-run "blank cream gaps" — this
    // observer used to require an element to be -8% INSIDE the viewport (rootMargin
    // "0px 0px -8% 0px") before revealing, so any section not yet dwelt-on for the
    // full .7s transition (a scroll-jump verification script, or a fast mobile flick)
    // rendered as a fully-laid-out but fully-transparent block matching the page
    // background. Fix: trigger up to 600px BEFORE the section enters view (positive
    // bottom rootMargin) so the fade always finishes well ahead of the visitor's eye.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px 600px 0px" });
    $$(".reveal").forEach(function (el) { io.observe(el); });
    // Belt-and-braces: force-reveal anything still unrevealed 2s after load (covers any
    // edge case where a .reveal element sits outside the expanded margin at load, e.g.
    // deep-link/anchor-jump past the top) so nothing can stay permanently blank.
    setTimeout(function () {
      $$(".reveal:not(.in)").forEach(function (el) { el.classList.add("in"); });
    }, 2000);
  } else {
    $$(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  (function () {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return;
    $$("[data-tilt-card]").forEach(function (card) {
      var limit = Number(card.getAttribute("data-tilt-limit") || 7);
      function reset() {
        card.classList.remove("is-tilting");
        card.style.setProperty("--tilt-x", "0deg");
        card.style.setProperty("--tilt-y", "0deg");
        card.style.setProperty("--tilt-z", "0px");
      }
      card.addEventListener("mousemove", function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var tiltY = (px - 0.5) * (limit * 2);
        var tiltX = (0.5 - py) * (limit * 2);
        card.classList.add("is-tilting");
        card.style.setProperty("--tilt-x", tiltX.toFixed(2) + "deg");
        card.style.setProperty("--tilt-y", tiltY.toFixed(2) + "deg");
        card.style.setProperty("--tilt-z", "-4px");
      });
      card.addEventListener("mouseleave", reset);
      card.addEventListener("blur", reset, true);
    });
  })();

  function setCartCount(count) {
    cartCountEls.forEach(function (el) { el.textContent = count; });
  }
  function setCartStatus(text) {
    if (cartStatus) cartStatus.textContent = text;
  }
  function cartRootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
  }
  function fetchCartData() {
    return fetch(cartRootPath() + "cart.js", { headers: { "Accept": "application/json" } }).then(function (response) {
      if (!response.ok) throw new Error("Cart request failed");
      return response.json();
    });
  }
  function renderCartUpsell(cart) {
    if (!cartUpsell) return;
    var items = cart.items || [];
    var hasFlagship = items.some(function (item) { return item.product_id === HW_FLAGSHIP_PRODUCT_ID; });
    var hasUpsell = items.some(function (item) { return item.product_id === HW_UPSELL_PRODUCT_ID; });
    if (!hasFlagship || hasUpsell) {
      cartUpsell.hidden = true;
      cartUpsell.innerHTML = "";
      return;
    }
    cartUpsell.hidden = false;
    // cart-fix-20260906 C3: demoted from a gold-button "primary action" card to a quiet,
    // default-off opt-in checkbox row - the drawer keeps exactly one gold button (Secure
    // checkout). Same eyebrow/title/description copy as before, byte-for-byte; only the
    // control changes from <button class="btn ..."> to an unchecked <input type=checkbox>.
    cartUpsell.innerHTML = [
      '<div class="cart-drawer__upsell-quiet">',
      '<style>.cart-drawer__upsell-quiet{padding:.65rem 0 0;margin-top:.5rem;border-top:1px solid var(--line-dark,#e4ddd0);}',
      '.cart-drawer__upsell-toggle{display:flex;align-items:flex-start;gap:.6rem;cursor:pointer;}',
      '.cart-drawer__upsell-toggle input{margin-top:.2rem;width:16px;height:16px;flex:none;accent-color:var(--gold-deep,#9a7b2e);}',
      '.cart-drawer__upsell-eyebrow{display:block;font-size:.72rem;letter-spacing:.03em;text-transform:uppercase;color:var(--ink-soft,#6b6459);}',
      '.cart-drawer__upsell-title{display:block;margin:.1rem 0 0;font-size:.86rem;font-weight:700;color:var(--ink,#1a1a2e);}',
      '.cart-drawer__upsell-text{display:block;margin:.15rem 0 0;font-size:.78rem;line-height:1.4;color:var(--ink-soft,#6b6459);}',
      '</style>',
      '<label class="cart-drawer__upsell-toggle">',
      '<input type="checkbox" data-upsell-add="' + HW_UPSELL_VARIANT_ID + '">',
      '<span>',
      '<span class="cart-drawer__upsell-eyebrow">Complete the keepsake</span>',
      '<span class="cart-drawer__upsell-title">Add the digital copy - &pound;12</span>',
      '<span class="cart-drawer__upsell-text">A digital file of the exact portrait we print, matched to the exact artwork you reviewed once it is ready. Yours to keep, share, or print again later.</span>',
      '</span>',
      '</label>',
      '</div>'
    ].join("");
  }
  function addUpsellToCart(variantId) {
    if (upsellPending) return;
    hwMarkAtcActivity();
    upsellPending = true;
    var btn = cartUpsell ? $("[data-upsell-add]", cartUpsell) : null;
    if (btn) { btn.disabled = true; }
    fetch(cartRootPath() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error("Add-on failed");
      return response.json();
    }).then(function () {
      showToast("<b>Added</b><p>The digital copy has been added to your cart.</p>");
      return refreshCartDrawer(false);
    }).catch(function () {
      showToast("<b>Could not add that</b><p>Please try again.</p>");
    }).finally(function () {
      upsellPending = false;
    });
  }
  if (cartUpsell) {
    cartUpsell.addEventListener("change", function (e) {
      var input = e.target.closest("[data-upsell-add]");
      if (!input || !input.checked) return;
      hwCapture("hw_upsell_tapped", { surface: "drawer" });
      addUpsellToCart(input.getAttribute("data-upsell-add"));
    });
  }
  function updateCartShipping(total) {
    // HW honesty-fix 2026-07-14: UK shipping is unconditionally free (no minimum) — always show the
    // honest static line instead of a spend-threshold message. `total` kept unused to avoid touching the
    // single call site in renderCartDrawer().
    if (!cartShipping) return;
    var textEl = cartShipping.querySelector(".cart-drawer__reward-text");
    if (!textEl) return;
    textEl.textContent = "✓ Free UK shipping included";
    cartShipping.classList.add("is-unlocked");
  }
  // checkout-trust-2026-07-23: honest computed cart-drawer delivery date (law 28). Mirrors the PDP's own
  // #deliveryEstimate 8/10-day estimate (theme.js render(), "isLongLead" on Framed/Canvas variants) so the
  // two surfaces never contradict each other. Uses the LONGEST lead time across cart line items — the whole
  // order ships together, so the worst-case item governs the honest promise (never understate the wait).
  var CART_DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var CART_MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  function formatCartEstDate(d) {
    return CART_DAY_NAMES[d.getDay()] + " " + d.getDate() + " " + CART_MONTH_NAMES[d.getMonth()];
  }
  function updateCartDelivery(cart) {
    if (!cartDelivery) return;
    var items = cart.items || [];
    if (!items.length) { cartDelivery.hidden = true; cartDelivery.textContent = ""; return; }
    var isLongLead = items.some(function (item) {
      return /^Framed|^Canvas/.test(item.variant_title || item.product_title || item.title || "");
    });
    var estDays = isLongLead ? 10 : 8;
    var estDate = new Date(Date.now() + estDays * 86400000);
    cartDelivery.textContent = "Order today — most portraits arrive by around " + formatCartEstDate(estDate) + ".";
    cartDelivery.hidden = false;
  }
  function hwFormatTrueImage(variantTitle) {
    // cart-fix-20260906 C4: a small, deliberately duplicated table (format -> the SAME live CDN
    // photo the PDP's own variantPreviewMap already uses for that format) -- the PDP's map lives
    // inside the #MainProduct closure and is not reachable from here, so this avoids a risky
    // cross-closure refactor under a turn cap. No new images (rule: never upload new product
    // images). Matched by substring against variant_title so every pet-count variant of a format
    // (e.g. "Framed / 12x18 / 2 Pets") still resolves. Verified live: Poster/Canvas variants
    // already carry this exact featured_image; every Framed variant and every multi-pet variant
    // of any format carries none, which is why the cart/drawer showed a stock print regardless of
    // format chosen (E10) -- this map is what actually fixes that, not Shopify's own item.image.
    var map = {
      Poster: "https://cdn.shopify.com/s/files/1/1045/5849/4036/files/pdp-poster-only-01.png?v=1783527642",
      Framed: "https://cdn.shopify.com/s/files/1/1045/5849/4036/t/7/assets/pdp-inroom-bedroom-restaged.jpg?v=1783692745",
      Canvas: "https://cdn.shopify.com/s/files/1/1045/5849/4036/files/pdp-canvas-only-01.png?v=1783527642"
    };
    if (!variantTitle) return null;
    var found = Object.keys(map).filter(function (k) { return variantTitle.indexOf(k) !== -1; })[0];
    return found ? map[found] : null;
  }
  function hwCartLineThumb(item) {
    // cart-fix-20260906 C2+C4: one shared thumbnail pick for the drawer AND the cart page.
    // Priority: their own AI preview > their own uploaded photo > the format-true variant image
    // > Shopify's own item.image. `fallback` is used as an onerror target so a broken/expired
    // preview URL never shows as a broken image -- it degrades to the format-true photo instead.
    var props = item.properties || {};
    if (props["_Preview"] || props["Preview"]) {
      return {
        src: props["_Preview"] || props["Preview"],
        alt: "Your AI preview of " + (item.product_title || item.title),
        caption: "your free AI preview \u2014 the final is hand-checked before print",
        fallback: hwFormatTrueImage(item.variant_title) || item.image || null
      };
    }
    if (props["_Pet Photo"] || props["Pet Photo"]) {
      return {
        src: props["_Pet Photo"] || props["Pet Photo"],
        alt: "Your photo of " + (item.product_title || item.title),
        caption: "your photo \u2014 we craft from this",
        fallback: hwFormatTrueImage(item.variant_title) || item.image || null
      };
    }
    var formatTrue = hwFormatTrueImage(item.variant_title);
    if (formatTrue) {
      return { src: formatTrue, alt: item.product_title || item.title, caption: "", fallback: item.image || null };
    }
    return { src: item.image || null, alt: item.product_title || item.title, caption: "", fallback: null };
  }
  function hwThumbImgHtml(thumb, width, height) {
    if (!thumb || !thumb.src) return "";
    var fallbackAttr = "";
    var onerrorAttr = "";
    if (thumb.fallback && thumb.fallback !== thumb.src) {
      fallbackAttr = ' data-hw-fallback="' + thumb.fallback + '"';
      onerrorAttr = ' onerror="if(this.dataset.hwFallback){this.src=this.dataset.hwFallback;this.removeAttribute(&quot;data-hw-fallback&quot;);}this.onerror=null;"';
    }
    return '<img src="' + thumb.src + '" alt="' + thumb.alt + '" loading="lazy" width="' + width + '" height="' + height + '"' + fallbackAttr + onerrorAttr + '>';
  }
  function hwCaptionHtml(thumb) {
    if (!thumb || !thumb.caption) return "";
    return '<div class="cart-drawer__photo-caption" style="font-size:.74rem;color:var(--ink-soft,#6b6459);margin-top:.2rem;line-height:1.3;">' + thumb.caption + '</div>';
  }
  function hwCartDrawerProps(cart, source) {
    var hasPreview = false, hasPhoto = false, format = null;
    (cart && cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      Object.keys(props).forEach(function (key) {
        var val = props[key];
        if (val == null || val === "") return;
        if (key === "Preview" || key === "_Preview") hasPreview = true;
        if (key === "Pet Photo" || key === "_Pet Photo" || String(val).indexOf("/uploads/") !== -1) hasPhoto = true;
      });
      if (!format && item.variant_title && item.variant_title !== "Default Title") format = item.variant_title;
    });
    return { has_preview: hasPreview, has_photo: hasPhoto, format: format, source: source || null };
  }
  function renderCartDrawer(cart) {
    if (!cartBody || !cartFooter || !cartSubtotal) return;
    hwLastCart = cart;
    setCartCount(cart.item_count || 0);
    cartSubtotal.textContent = formatMoney(cart.total_price || 0);
    updateCartShipping(cart.total_price || 0);
    updateCartDelivery(cart);
    renderCartUpsell(cart);
    if (!cart.items || !cart.items.length) {
      setCartStatus("Your cart is empty right now.");
      cartFooter.hidden = true;
      cartBody.innerHTML = [
        '<div class="cart-drawer__empty">',
        '<strong>No portraits waiting yet</strong>',
        '<p>Start with your custom portrait or the gift box, then use 48 hours to approve the exact proof or request free changes.</p>',
        '<div class="cart-drawer__actions">',
        '<a href="/products/custom-pet-portrait" class="btn btn--lg">Start Your Portrait <span class="arr">→</span></a>',
        '<a href="/products/the-royal-treatment-box-personalised-dog-gift-box" class="btn btn--ghost btn--block" style="color:var(--ink);box-shadow:inset 0 0 0 1px var(--line-dark);">Buy The Gift Box</a>',
        '</div>',
        '</div>'
      ].join("");
      return;
    }

    setCartStatus("Your portrait is in the cart. After checkout, you get the exact proof and 48 hours to approve or request free changes.");
    cartFooter.hidden = false;
    cartBody.innerHTML = cart.items.map(function (item) {
      var props = "";
      Object.keys(item.properties || {}).forEach(function (key) {
        var value = item.properties[key];
        if (value == null || value === "") return;
        if (key.charAt(0) === "_") return; // internal app properties (e.g. _gc_ext_*) never render to customers
        // cart-fix-20260906 C2: Preview/Pet Photo now render as the line's thumbnail image with an
        // honest caption (see hwCartLineThumb/hwCaptionHtml below) -- never also as a raw property
        // line, which is exactly the un-honest-looking raw-URL text this build removes (E9).
        if (key === "Preview" || key === "Pet Photo") return;
        if (String(value).indexOf("/uploads/") !== -1) props += '<div>' + key + ': <a href="' + value + '" style="color:var(--gold-deep);text-decoration:underline;">uploaded photo</a></div>';
        else props += '<div>' + key + ': ' + value + '</div>';
      });
      var variant = "";
      if (item.variant_title && item.variant_title !== "Default Title") {
        variant = '<div class="cart-drawer__variant">' + item.variant_title +
          ' <button type="button" class="cart-drawer__change-format" data-cart-change-format data-format-url="' + item.url + '" ' +
          'style="background:none;border:0;padding:0;margin-left:.35rem;font:inherit;font-size:.78rem;' +
          'text-decoration:underline;color:var(--gold-deep,#9a7b2e);cursor:pointer;">Change format</button></div>';
      }
      var thumb = hwCartLineThumb(item);
      var image = hwThumbImgHtml(thumb, 176, 220);
      var photoCaption = hwCaptionHtml(thumb);
      // cart-fix-20260906 C1: drawer line for a cart with no Preview property -- degrades to
      // nothing (no markup at all) if the widget isn't on this page or previews are paused/locked,
      // exactly like the buybar/buybox affordances. Re-evaluated every render, so no live listener
      // is needed here the way the static buybar button needs one.
      var previewLine = "";
      if (!(item.properties && (item.properties["_Preview"] || item.properties["Preview"])) &&
          document.getElementById("hw-free-preview") &&
          !document.documentElement.classList.contains("hw-previews-paused")) {
        previewLine = '<div class="cart-drawer__preview-nudge">' +
          '<button type="button" data-cart-preview-link ' +
          'style="background:none;border:0;padding:0;margin:.35rem 0 0;font:inherit;font-size:.82rem;' +
          'text-decoration:underline;color:var(--gold-deep,#9a7b2e);cursor:pointer;text-align:left;">' +
          'Not sure it will look like them? See a free preview first</button></div>';
      }
      return [
        '<article class="cart-drawer__item">',
        '<a class="cart-drawer__thumb" href="', item.url, '">', image, '</a>',
        '<div>',
        photoCaption,
        '<a class="cart-drawer__title" href="', item.url, '">', item.product_title || item.title, '</a>',
        variant,
        previewLine,
        props ? '<div class="cart-drawer__properties">' + props + '</div>' : '',
        '<div class="cart-drawer__row">',
        '<div class="cart-drawer__qty" data-cart-key="', item.key, '">',
        '<button type="button" data-cart-qty="-1" aria-label="Decrease quantity">-</button>',
        '<span>', item.quantity, '</span>',
        '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>',
        '</div>',
        '<span class="cart-drawer__line-price">', formatMoney(item.final_line_price), '</span>',
        '</div>',
        '<button type="button" class="cart-drawer__remove" data-cart-remove="', item.key, '">Remove</button>',
        '</div>',
        '</article>'
      ].join("");
    }).join("");
  }
  function hydrateCartPageProperties(cart) {
    var rows = $$("[data-cart-line-key]");
    if (!rows.length || !cart || !cart.items) return;
    rows.forEach(function (row) {
      var item = cart.items.find(function (entry) { return entry.key === row.getAttribute("data-cart-line-key"); });
      if (!item || !item.properties) return;
      var publicKeys = Object.keys(item.properties).filter(function (key) {
        var value = item.properties[key];
        return key.charAt(0) !== "_" && value != null && value !== "" && key !== "Preview" && key !== "Pet Photo";
      });
      // cart-fix-20260906 C2+C4: swap the server-rendered thumbnail for the shopper's own
      // preview/photo, or the format-true variant image, using the SAME picker the drawer uses --
      // the two surfaces can never disagree about which image represents a line.
      var hwThumb = hwCartLineThumb(item);
      var hwMedia = row.querySelector(".cart-premium__item-media");
      var hwImg = hwMedia && hwMedia.querySelector("img");
      if (hwImg && hwThumb.src) {
        hwImg.removeAttribute("srcset");
        hwImg.removeAttribute("sizes");
        hwImg.src = hwThumb.src;
        hwImg.alt = hwThumb.alt;
        if (hwThumb.fallback && hwThumb.fallback !== hwThumb.src) {
          hwImg.setAttribute("data-hw-fallback", hwThumb.fallback);
          hwImg.onerror = function () {
            if (hwImg.dataset.hwFallback) { hwImg.src = hwImg.dataset.hwFallback; hwImg.removeAttribute("data-hw-fallback"); }
            hwImg.onerror = null;
          };
        }
      }
      var hwCopyCol = row.querySelector(".cart-premium__item-copy");
      if (hwCopyCol) {
        var hwCap = hwCopyCol.querySelector(".cart-premium__photo-caption");
        if (hwThumb.caption) {
          if (!hwCap) {
            hwCap = document.createElement("div");
            hwCap.className = "cart-premium__photo-caption";
            hwCap.style.cssText = "font-size:.74rem;color:var(--ink-soft,#6b6459);margin-bottom:.35rem;line-height:1.3;";
            hwCopyCol.insertBefore(hwCap, hwCopyCol.firstChild);
          }
          hwCap.textContent = hwThumb.caption;
        } else if (hwCap) {
          hwCap.remove();
        }
      }
      if (!publicKeys.length) return;
      var container = row.querySelector(".cart-premium__props");
      if (!container) {
        container = document.createElement("div");
        container.className = "cart-premium__props";
        var actions = row.querySelector(".cart-premium__item-actions");
        if (actions) actions.parentNode.insertBefore(container, actions);
      }
      var shown = Array.prototype.map.call(container.querySelectorAll("strong"), function (label) {
        return label.textContent.replace(/:$/, "");
      });
      publicKeys.forEach(function (key) {
        if (shown.indexOf(key) !== -1) return;
        var line = document.createElement("div");
        var label = document.createElement("strong");
        label.textContent = key;
        line.appendChild(label);
        var value = String(item.properties[key]);
        if (value.indexOf("/uploads/") !== -1) {
          var link = document.createElement("a");
          link.href = value;
          link.textContent = "uploaded photo";
          link.style.color = "var(--gold-deep)";
          link.style.textDecoration = "underline";
          line.appendChild(link);
        } else {
          var text = document.createElement("span");
          text.textContent = value;
          line.appendChild(text);
        }
        container.appendChild(line);
      });
    });
  }
  function refreshCartDrawer(openAfter, expectedCount, retriesLeft) {
    if (!cartBody) return Promise.resolve();
    retriesLeft = typeof retriesLeft === "number" ? retriesLeft : 2;
    cartBody.innerHTML = '<div class="cart-drawer__loading">Refreshing your cart</div>';
    setCartStatus("Loading your cart...");
    return fetchCartData().then(function (cart) {
      if (typeof expectedCount === "number" && cart.item_count < expectedCount && retriesLeft > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(refreshCartDrawer(openAfter, expectedCount, retriesLeft - 1));
          }, 180);
        });
      }
      renderCartDrawer(cart);
      hydrateCartPageProperties(cart);
      if (openAfter) {
        hwCapture("hw_cart_drawer_opened", hwCartDrawerProps(cart, hwLastAddSource || "icon"));
        hwLastAddSource = null;
        toggleCart(true);
      }
      return cart;
    }).catch(function () {
      setCartStatus("We could not refresh the cart just now.");
      cartFooter && (cartFooter.hidden = true);
      cartBody.innerHTML = '<div class="cart-drawer__empty"><strong>Cart unavailable</strong><p>Please try again in a moment, or use the full cart page if the issue persists.</p><a href="/cart" class="btn btn--lg">View cart <span class="arr">→</span></a></div>';
    });
  }
  function changeCartLine(key, quantity) {
    if (cartPending) return;
    cartPending = true;
    setCartStatus("Updating your cart...");
    return fetch(cartRootPath() + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart update failed");
      return response.json();
    }).then(function (cart) {
      renderCartDrawer(cart);
      showToast("<b>Cart updated</b><p>Your cart has been refreshed.</p>");
    }).catch(function () {
      showToast("<b>Cart update failed</b><p>Please try that again.</p>");
      return refreshCartDrawer(false);
    }).finally(function () {
      cartPending = false;
    });
  }

  // cart-fix-20260906 C2: the free-preview widget adds its own item via /cart/add.js and then
  // signals here to open the SAME drawer every other Add-to-cart path uses, instead of navigating
  // to /cart (E9) -- one cart-review surface for every path, source:"preview" matches the design
  // spec's data-flow step 4.
  document.addEventListener("hw:open-cart-drawer", function (e) {
    hwLastAddSource = (e.detail && e.detail.source) || "preview";
    refreshCartDrawer(true);
  });
  cartOpenEls.forEach(function (el) {
    el.addEventListener("click", function () {
      hwLastAddSource = "icon";
      refreshCartDrawer(true);
    });
  });
  cartCloseEls.forEach(function (el) {
    el.addEventListener("click", function () { toggleCart(false); });
  });
  if (cartScrim) cartScrim.addEventListener("click", function () { toggleCart(false); });
  // cart-fix-20260906 C0: uses the LAST cart.js payload already rendered into the drawer
  // (hwLastCart, set in renderCartDrawer) instead of an async fetch here - a fetch begun on
  // click would race the button's native form submit / navigation to the hosted checkout.
  if (secureCheckoutBtn) {
    secureCheckoutBtn.addEventListener("click", function () {
      var props = hwCartDrawerProps(hwLastCart, null);
      hwCapture("hw_secure_checkout_tapped", { has_preview: props.has_preview, format: props.format, express: false });
    });
  }
  if (cartExpressWrap) {
    cartExpressWrap.addEventListener("click", function (e) {
      var provider = "unknown";
      try {
        var el = e.target.closest("button, [role=\"button\"], a") || e.target;
        var label = ((el && (el.getAttribute("aria-label") || el.textContent)) || "").toLowerCase();
        if (label.indexOf("shop") !== -1) provider = "shop_pay";
        else if (label.indexOf("paypal") !== -1) provider = "paypal";
        else if (label.indexOf("google") !== -1) provider = "google_pay";
      } catch (err) {}
      hwCapture("hw_express_pay_tapped", { provider: provider });
    }, true);
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && cartDrawer && cartDrawer.classList.contains("open")) {
      toggleCart(false);
    }
  });
  if (cartBody) {
    cartBody.addEventListener("click", function (e) {
      var qtyBtn = e.target.closest("[data-cart-qty]");
      if (qtyBtn) {
        var qtyWrap = qtyBtn.closest("[data-cart-key]");
        if (!qtyWrap) return;
        var current = Number($("span", qtyWrap).textContent || "1");
        var nextQty = Math.max(0, current + Number(qtyBtn.getAttribute("data-cart-qty") || "0"));
        changeCartLine(qtyWrap.getAttribute("data-cart-key"), nextQty);
        return;
      }
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (removeBtn) { changeCartLine(removeBtn.getAttribute("data-cart-remove"), 0); return; }
      var formatBtn = e.target.closest("[data-cart-change-format]");
      if (formatBtn) {
        var formatGroup = document.querySelector("[data-option-name=\"Format\"]");
        if (formatGroup) {
          toggleCart(false);
          setTimeout(function () { formatGroup.scrollIntoView({ behavior: "smooth", block: "center" }); }, 260);
        } else {
          window.location.href = formatBtn.getAttribute("data-format-url") || "/products/custom-pet-portrait";
        }
        return;
      }
      var previewLinkBtn = e.target.closest("[data-cart-preview-link]");
      if (previewLinkBtn) {
        hwCapture("hw_preview_link_tapped", { source: "drawer" });
        var previewTarget = document.getElementById("hw-free-preview");
        toggleCart(false);
        if (previewTarget) {
          setTimeout(function () { previewTarget.scrollIntoView({ behavior: "smooth", block: "start" }); }, 260);
        }
        return;
      }
    });
  }
  refreshCartDrawer(false);

  var root = $("#MainProduct");
  if (root) {
    if (paidPath) {
      document.documentElement.classList.add("hw-paid-path");
      root.setAttribute("data-paid-path", "true");
      var sub = $(".buybox .sub", root);
      if (sub) sub.textContent = "Order today, then approve your proof before we print. AI-crafted, human-reviewed, and backed by the Love-It Guarantee.";
      var ctaWrap = $(".buybox__cta", root);
      if (ctaWrap && !ctaWrap.querySelector(".field-note--paid")) {
        var paidNote = document.createElement("p");
        paidNote.className = "field-note field-note--paid";
        paidNote.style.textAlign = "center";
        paidNote.textContent = "This paid-traffic page is buy-first on purpose. Your proof still arrives before anything prints.";
        ctaWrap.appendChild(paidNote);
      }
      var uploadTitle = $(".upload__title", root);
      var uploadHint = $(".upload__hint", root);
      if (uploadTitle) uploadTitle.textContent = "Upload your pet photo now or after checkout";
      if (uploadHint) uploadHint.textContent = "Fastest path: add to cart now, then send the photo if you are ready.";
    }

    var dataEl = $("#ProductJson", root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $("#product-form", root);
    var idInput = $("#variantId", root);
    var priceEl = $("#price", root);
    var compareEl = $("#price-compare", root);
    var saveEl = $("#price-save", root);
    var ctaBtn = $("#mainCta", root);
    var barPrice = $("#barPrice");
    var barBtn = $("#barCta");
    var barPreviewBtn = $("#barPreviewBtn");
    var ctaPrefix = root.getAttribute("data-cta-prefix") || "Add to cart";
    var stickyCta = root.getAttribute("data-sticky-cta") || ctaPrefix;
    var quickJumpTarget = root.getAttribute("data-quick-jump-target") || "#mainCta";
    var optionGroups = $$("[data-option-index]", root);
    var upload = $("#upload", root);
    var fileInput = $("#fileInput", root);
    var quickAdd = $("#pdpQuickAdd", root);
    var quickJump = $("#pdpQuickJump", root);
    var bumpEl = $("#bump", root);
    var thumbs = $$(".pdp__thumb", root);
    var mainImg = $("#pdpMain img", root);
    var deliveryEl = $("#deliveryEstimate", root);
    var hasFile = false;
    var DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    function formatEstDate(d) {
      return DAY_NAMES[d.getDay()] + " " + d.getDate() + " " + MONTH_NAMES[d.getMonth()];
    }
    function setMainImage(src, alt) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute("srcset");
      mainImg.removeAttribute("sizes");
      mainImg.src = src.indexOf("//") === 0 ? "https:" + src : src;
      if (alt) mainImg.alt = alt;
    }
    if (thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () {
          thumbs.forEach(function (x) { x.classList.remove("active"); });
          t.classList.add("active");
          setMainImage(t.getAttribute("data-img"));
        });
      });
    }
    var styleMap = {
      realistic: {
        img: "https://cdn.shopify.com/s/files/1/1045/5849/4036/files/attempt1-nanobananapro-corrected-prompt_5466a43d-53d2-427e-9acb-0dc72efe2f90.png?v=1783596698",
        label: "Realistic style example"
      },
      "fine-art": {
        img: "https://cdn.shopify.com/s/files/1/1045/5849/4036/t/7/assets/real-portrait-finearrt-samedog.jpg?v=1783689484",
        label: "Fine-art oil-painting style example"
      }
    };
    // 2026-07-10 fix-pdp-batch2 Fix C: Style x Format combined preview map. This is
    // NOT a resurrection of the per-variant featured_image bug banned in the
    // 2026-07-09 comment below (theme.js render()) - that bug silently pulled an
    // unrelated Shopify variant-level image on EVERY option change regardless of
    // the on-screen style label. This map is hand-authored, keyed by BOTH the
    // current style pill AND the current Format pill together, so whichever one
    // changes, the preview always stays consistent with both selections at once
    // (never mismatched). Cells with no distinct photo yet fall back to the
    // style's default hero image (styleMap[key]) rather than showing nothing -
    // see Fix C report entry for which cells are real vs. fallback.
    var variantPreviewMap = {
      realistic: {
        Poster: {
          img: "https://cdn.shopify.com/s/files/1/1045/5849/4036/files/pdp-poster-only-01.png?v=1783527642",
          label: "Realistic style - Poster finish example"
        },
        Framed: {
          img: "https://cdn.shopify.com/s/files/1/1045/5849/4036/t/7/assets/pdp-inroom-bedroom-restaged.jpg?v=1783692745",
          label: "Realistic style - Framed finish example, shown true-to-scale on a wall"
        },
        Canvas: {
          img: "https://cdn.shopify.com/s/files/1/1045/5849/4036/files/pdp-canvas-only-01.png?v=1783527642",
          label: "Realistic style - Canvas finish example"
        }
      },
      // 2026-07-10 Fix D: filled in from the new gallery-variety photoreal shoot.
      // fine-art|Poster still has no distinct photo (flagged as an open gap below)
      // and correctly falls back to styleMap["fine-art"].
      "fine-art": {
        Framed: {
          img: "https://cdn.shopify.com/s/files/1/1045/5849/4036/files/pdp-spaniel-memorial-framed-01_7a256db4-77eb-4215-8cad-7dde7be60d83.png?v=1783676250",
          label: "Fine-art style - Framed finish example"
        },
        Canvas: {
          img: "https://cdn.shopify.com/s/files/1/1045/5849/4036/files/pdp-pug-finearrt-canvas-01_81024dc6-d9ef-4879-a033-954605687176.png?v=1783676251",
          label: "Fine-art style - Canvas finish example"
        }
      }
    };
    function currentStyleKey() {
      var checked = stylePillsWrap && $("input:checked", stylePillsWrap);
      var pillEl = checked && checked.closest(".pill");
      return pillEl ? pillEl.getAttribute("data-style") : "realistic";
    }
    var formatOptionGroup = optionGroups.filter(function (g) { return g.getAttribute("data-option-name") === "Format"; })[0];
    function currentFormatValue() {
      if (!formatOptionGroup) return null;
      var checked = $("input:checked", formatOptionGroup);
      return checked ? checked.value : null;
    }
    function updateVariantPreview() {
      var styleKey = currentStyleKey();
      var formatVal = currentFormatValue();
      var byFormat = variantPreviewMap[styleKey];
      var entry = (byFormat && formatVal && byFormat[formatVal]) || styleMap[styleKey];
      if (entry) {
        setMainImage(entry.img, entry.label);
        if (styleConfirmEl) {
          var styleLabel = styleKey === "fine-art" ? "The Gallery" : "The Heirloom";
          styleConfirmEl.textContent = "Showing: " + styleLabel + (formatVal ? " - " + formatVal : "") + " example";
        }
      }
    }
    var stylePillsWrap = $("#stylePills", root);
    var stylePropInput = $("#stylePropertyInput", root);
    var styleEnginePropInput = $("#styleEnginePropertyInput", root);
    var styleValEl = $("#styleVal", root);
    var styleConfirmEl = $("#styleConfirm", root);
    if (stylePillsWrap) {
      stylePillsWrap.addEventListener("change", function () {
        var checked = $("input:checked", stylePillsWrap);
        if (!checked) return;
        $$(".pill", stylePillsWrap).forEach(function (p) { p.classList.toggle("active", p.contains(checked)); });
        var pillEl = checked.closest(".pill");
        var key = pillEl ? pillEl.getAttribute("data-style") : "realistic";
        var label = checked.value;
        var publicStyleLabel = key === "fine-art" ? "The Gallery" : "The Heirloom";
        if (stylePropInput) stylePropInput.value = publicStyleLabel;
        if (styleEnginePropInput) styleEnginePropInput.value = label;
        if (styleValEl) styleValEl.textContent = publicStyleLabel;
        updateVariantPreview();
      });
    }
    var hwPrevFormat = currentFormatValue();
    if (formatOptionGroup) {
      formatOptionGroup.addEventListener("change", function () {
        var hwNextFormat = currentFormatValue();
        hwCapture("hw_format_changed", { from: hwPrevFormat, to: hwNextFormat });
        hwPrevFormat = hwNextFormat;
        updateVariantPreview();
      });
    }

    function selectedOptions() {
      return optionGroups.map(function (g) {
        var checked = $("input:checked", g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }
    function updateLabels() {
      optionGroups.forEach(function (g) {
        var checked = $("input:checked", g);
        var valEl = $(".val", g);
        $$(".pill", g).forEach(function (p) { p.classList.toggle("active", p.contains(checked)); });
        if (checked && valEl) valEl.textContent = checked.value;
      });
    }
    function bumpCents() {
      return (bumpEl && bumpEl.checked) ? (Number(bumpEl.getAttribute("data-addon-price-cents")) || 0) : 0;
    }
    function render() {
      updateLabels();
      var v = findVariant(selectedOptions());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.style.display = "";
          compareEl.textContent = formatMoney(v.compare_at_price);
          if (saveEl) {
            saveEl.style.display = "";
            saveEl.textContent = "Save " + formatMoney(v.compare_at_price - v.price);
          }
        } else {
          compareEl.style.display = "none";
          if (saveEl) saveEl.style.display = "none";
        }
      }
      if (barPrice && barPrice.childNodes[0]) barPrice.childNodes[0].nodeValue = formatMoney(v.price + bumpCents());
      if (ctaBtn) {
        if (v.available) {
          ctaBtn.disabled = false;
          ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = ctaPrefix + " - " + formatMoney(v.price + bumpCents()));
        } else {
          ctaBtn.disabled = true;
          ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = "Sold out");
        }
      }
      // 2026-07-09 fix-gallery-royal-lead: removed the per-variant featured_image
      // override here. It silently hijacked the main gallery image + thumbnail
      // active-state on every Format/Size change (and on initial render() call),
      // clobbering whatever the Realistic/Fine-Art/Royal style pill had set via
      // setMainImage()/styleMap above (theme.js:579-612) with an unrelated
      // Shopify variant-level image, mismatched to the on-screen style label
      // (e.g. Royal costume shown while the label still read "Showing: Realistic
      // style example"). Format/Size must only ever affect price/CTA/delivery
      // estimate below — never the gallery image. The style pill (styleMap) is
      // the single owner of the main image; the initial SSR image (main-product.liquid,
      // product.media.first) is the single owner of the pre-interaction default.
      // Tier1 gap-close (2026-08-15): the memorial template renders its own
      // delivery copy server-side (sections/main-product.liquid) and owns it --
      // that element carries data-no-deadline="1" so this urgency overwrite
      // must never touch it, on load OR on variant change.
      if (deliveryEl && !deliveryEl.hasAttribute("data-no-deadline")) {
        var isLongLead = /^Framed|^Canvas/.test(v.title || "");
        var estDays = isLongLead ? 10 : 8;
        var estDate = new Date(Date.now() + estDays * 86400000);
        deliveryEl.textContent = "Need it for a birthday, memorial or anniversary? Order today - arrives by around " + formatEstDate(estDate) + ".";
      }
    }
    optionGroups.forEach(function (g) { g.addEventListener("change", render); });
    if (bumpEl) bumpEl.addEventListener("change", function () {
      if (bumpEl.checked) hwCapture("hw_upsell_tapped", { surface: "buybox" });
      render();
    });

    if (quickAdd && form) {
      quickAdd.addEventListener("click", function () {
        hwLastAddSource = "buybox";
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    if (quickJump) {
      quickJump.addEventListener("click", function () {
        var target = document.querySelector(quickJumpTarget) || $("#mainCta", root) || $("#buybox", root);
        if (!target) return;
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    if (upload && fileInput) {
      var prev = $(".upload__preview img", upload);
      var fname = $(".fname", upload);
      function setFile(file) {
        if (!file) return;
        hasFile = true;
        upload.classList.add("has-file");
        if (fname) fname.textContent = file.name;
        if (prev && file.type.indexOf("image/") === 0) {
          prev.src = URL.createObjectURL(file);
          prev.hidden = false;
          prev.removeAttribute("aria-hidden");
        }
      }
      fileInput.addEventListener("change", function (e) { setFile(e.target.files[0]); });
      ["dragover", "dragenter"].forEach(function (ev) {
        upload.addEventListener(ev, function (e) {
          e.preventDefault();
          upload.classList.add("drag");
        });
      });
      ["dragleave", "drop"].forEach(function (ev) {
        upload.addEventListener(ev, function (e) {
          e.preventDefault();
          upload.classList.remove("drag");
        });
      });
      upload.addEventListener("drop", function (e) {
        if (e.dataTransfer.files[0]) {
          fileInput.files = e.dataTransfer.files;
          setFile(e.dataTransfer.files[0]);
        }
      });
      var clr = $(".upload__clear", upload);
      if (clr) clr.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        hasFile = false;
        fileInput.value = "";
        upload.classList.remove("has-file");
        if (prev) {
          prev.removeAttribute("src");
          prev.hidden = true;
          prev.setAttribute("aria-hidden", "true");
        }
      });
    }

    if (ctaBtn) {
      ctaBtn.addEventListener("click", function () { hwLastAddSource = "buybox"; });
    }
    if (barBtn && form) {
      barBtn.textContent = stickyCta + " →";
      barBtn.addEventListener("click", function () {
        hwLastAddSource = "buybar";
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
    if (barPreviewBtn) {
      // cart-fix-20260906 C1: sticky-bar secondary action -- honours the ad's "see it first"
      // promise at the last decision point before Add to cart. Degrades to hidden (never a dead
      // button) if the widget section is absent from this product template, or if the widget has
      // already signalled previews are paused/locked.
      var previewSection = document.getElementById("hw-free-preview");
      if (!previewSection || document.documentElement.classList.contains("hw-previews-paused")) {
        barPreviewBtn.style.display = "none";
      }
      barPreviewBtn.addEventListener("click", function () {
        hwCapture("hw_preview_link_tapped", { source: "buybar" });
        var target = document.getElementById("hw-free-preview");
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
        // Standing the bar down is handled by the existing IntersectionObserver in
        // hw-free-preview-capture.liquid the moment the widget scrolls into view -- no new logic
        // needed here, same as the buy-box link.
      });
      document.addEventListener("hw:previews-paused", function () {
        barPreviewBtn.style.display = "none";
      });
    }
    // cart-fix-20260906 C4: small format-true thumbnails on the Format pills, reusing the SAME
    // images as variantPreviewMap's "realistic" row (no new images uploaded). Runs once; the
    // Format pill values never change after render, so no re-run is needed on style/format change.
    function addFormatPillThumbnails() {
      if (!formatOptionGroup) return;
      $$(".pill", formatOptionGroup).forEach(function (pill) {
        if (pill.querySelector(".pill__thumb")) return;
        var input = pill.querySelector("input");
        var val = input && input.value;
        if (!val) return;
        var entry = (variantPreviewMap.realistic && variantPreviewMap.realistic[val]) ||
          (variantPreviewMap["fine-art"] && variantPreviewMap["fine-art"][val]);
        if (!entry || !entry.img) return;
        var img = document.createElement("img");
        img.src = entry.img;
        img.alt = "";
        img.loading = "lazy";
        img.width = 28;
        img.height = 28;
        img.className = "pill__thumb";
        img.style.cssText = "width:28px;height:28px;border-radius:6px;object-fit:cover;margin-right:.4rem;vertical-align:middle;display:inline-block;";
        if (input && input.nextSibling) pill.insertBefore(img, input.nextSibling);
        else pill.appendChild(img);
      });
    }
    // First-load parity: updateVariantPreview() previously only ran on style/format CHANGE, so on
    // first paint the hero could mismatch the default selected format (E16). Also seeds the pill
    // thumbnails once.
    updateVariantPreview();
    addFormatPillThumbnails();

    var bar = $("#buybar");
    /* 2026-08-15 CORRECTION: was observing #pdpMain (the hero image), so the bar
       showed as soon as the visitor scrolled past the hero -- while the real
       Style/Format/Size controls, still further down inside #product-form, were
       on screen, and the bar rendered on top of them (manager fine-sweep found 5/29
       positions blocked, every one by the buybar). Observing the buy FORM itself
       makes "form visible" and "bar hidden" the same condition -- the two can no
       longer be on screen together, structurally, not by tuning a number. */
    var formEl = $("#product-form") || $("#pdpMain") || ctaBtn;
    if (bar && formEl && "IntersectionObserver" in window) {
      new IntersectionObserver(function (e) {
        bar.classList.toggle("show", !e[0].isIntersecting);
      }, { threshold: 0, rootMargin: "0px 0px -40px 0px" }).observe(formEl);
    }

    if (paidPath) {
      $$("a[href*='/pages/free-preview']").forEach(function (el) { el.style.display = "none"; });
      $$(".cta-or", root).forEach(function (el) { el.style.display = "none"; });
      $$(".pdp-spec__item", document).forEach(function (el) {
        if (/free preview first/i.test(el.innerText || "")) el.style.display = "none";
      });
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (cartPending) return;
        hwMarkAtcActivity();

        cartPending = true;
        if (ctaBtn) {
          ctaBtn.disabled = true;
          ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = "Adding to cart...");
        }

        var formData = new FormData(form);
        var currentCount = Number((cartCountEls[0] && cartCountEls[0].textContent) || "0");
        var expectedCount = currentCount + 1;
        fetch(cartRootPath() + "cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: formData
        }).then(function (response) {
          if (!response.ok) throw new Error("Add to cart failed");
          return response.json();
        }).then(function () {
          var bumpEl = $("#bump", root);
          if (bumpEl && bumpEl.checked && bumpEl.dataset.addonVariant) {
            expectedCount += 1;
            return fetch(cartRootPath() + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify({ items: [{ id: Number(bumpEl.dataset.addonVariant), quantity: 1 }] })
            }).then(function (response) {
              if (!response.ok) throw new Error("Add-on failed");
              return response.json();
            });
          }
          return null;
        }).then(function () {
          showToast("<b>Added to cart</b><p>Your portrait is in the cart. You can still review everything before checkout.</p>");
          return refreshCartDrawer(true, expectedCount);
        }).catch(function () {
          showToast("<b>Could not add to cart</b><p>Please try again. If the problem continues, use the full cart page.</p>");
        }).finally(function () {
          cartPending = false;
          render();
        });
      });
    }

    render();
  }

  (function () {
    var homeBar = $("#homeBuybar");
    if (!homeBar) return;
    if (window.matchMedia && !window.matchMedia("(max-width: 720px)").matches) return;
    var heroTrigger = $(".hero__cta") || $(".hero__trust") || $(".hero__mobile-stage") || $(".hero__grid") || $(".hero");
    if (!heroTrigger || !("IntersectionObserver" in window)) return;
    function setHomeBar(open) {
      var allow = open && window.scrollY > 260;
      homeBar.classList.toggle("show", allow);
      homeBar.setAttribute("aria-hidden", allow ? "false" : "true");
    }
    new IntersectionObserver(function (entries) {
      var offscreen = !entries[0].isIntersecting;
      setHomeBar(offscreen);
    }, { threshold: 0.16, rootMargin: "0px 0px -12% 0px" }).observe(heroTrigger);
    window.addEventListener("scroll", function () {
      if (window.scrollY <= 260) setHomeBar(false);
    }, { passive: true });
  })();

  (function () {
    var collectionBar = $("#collectionBuybar");
    if (!collectionBar) return;
    if (window.matchMedia && !window.matchMedia("(max-width: 879px)").matches) return;
    var trigger = $(".coll-premium__quick-grid") || $(".coll-premium__hero") || $(".coll-premium");
    if (!trigger || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      var offscreen = !entries[0].isIntersecting;
      collectionBar.classList.toggle("show", offscreen);
      collectionBar.setAttribute("aria-hidden", offscreen ? "false" : "true");
    }, { threshold: 0.18, rootMargin: "0px 0px -12% 0px" }).observe(trigger);
  })();

  (function () {
    var modal = $("#hwCaptureModal");
    if (!modal) return;
    var popupAllowed = captureTestMode ||
      document.body.classList.contains("template-article") ||
      document.body.classList.contains("template-blog");
    if (!popupAllowed) return;
    if (document.body.classList.contains("template-product") || document.body.classList.contains("template-paid-landing")) return;
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return;

    var storageKey = "hw_capture_popup_state";
    var popupShown = false;
    var success = modal.querySelector("[data-capture-success='true']");

    function getState() {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || "{}");
      } catch (err) {
        return {};
      }
    }

    function setState(next) {
      try {
        localStorage.setItem(storageKey, JSON.stringify(next));
      } catch (err) {}
    }

    function openModal() {
      var state = getState();
      if (popupShown || state.subscribed) return;
      if (!captureTestMode && document.getElementById("shopify-pc__banner")) {
        setTimeout(openModal, 6000);
        return;
      }
      popupShown = true;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
    }

    function closeModal(days) {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      if (days) setState({ dismissedUntil: Date.now() + (days * 24 * 60 * 60 * 1000) });
    }

    if (success) {
      setState({ subscribed: true, subscribedAt: Date.now() });
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      return;
    }

    var state = getState();
    if (state.subscribed) return;
    if (state.dismissedUntil && state.dismissedUntil > Date.now()) return;

    modal.querySelectorAll("[data-capture-close]").forEach(function (el) {
      el.addEventListener("click", function () { closeModal(7); });
    });

    var emailInput = modal.querySelector('input[type="email"]');
    if (emailInput) {
      modal.querySelector("form") && modal.querySelector("form").addEventListener("submit", function () {
        setState({ subscribed: true, subscribedAt: Date.now() });
      });
    }

    if (captureTestMode) {
      openModal();
      return;
    }

    var isTouch = window.matchMedia("(pointer: coarse)").matches;

    // Scroll-depth trigger. Mobile (touch / ~80% of traffic) fires at ~40% scroll, where
    // intent is shown but the visitor is about to bounce. Desktop relies on exit-intent first,
    // so it gets a later 60% scroll fallback to avoid interrupting an engaged reader.
    var scrollThreshold = isTouch ? 0.40 : 0.60;
    var scrollHandler = function () {
      if (popupShown) return;
      var scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      if ((window.scrollY / scrollable) >= scrollThreshold) {
        clearTimeout(delayTimer);
        openModal();
        window.removeEventListener("scroll", scrollHandler);
      }
    };
    window.addEventListener("scroll", scrollHandler, { passive: true });

    // Dwell fallback: if they never scroll past the threshold and never exit-intent, show after a
    // long dwell so engaged-but-static readers still get the offer. Mobile gets a longer wait so
    // the scroll trigger leads; desktop relies on exit-intent, this is just a safety net.
    var delayTimer = setTimeout(openModal, isTouch ? 30000 : 22000);

    // Exit-intent (desktop only) — mouse leaves the top of the viewport.
    document.addEventListener("mouseout", function (event) {
      if (popupShown || isTouch) return;
      if (event.relatedTarget === null && event.clientY <= 12) {
        clearTimeout(delayTimer);
        openModal();
      }
    });
  })();

  // ---------------------------------------------------------------------
  // HW Welcome10 popup (#hwWelcome10Modal) -- sitewide 10%-off-first-order
  // capture, built 2026-08-12 (master-plan P0 item 3). Distinct from the
  // #hwCaptureModal block above (CROWN20 free-preview lead magnet, blog/
  // article only, desktop-only): this one runs on BOTH mobile and desktop
  // (mobile bottom-sheet is a spec requirement) and only ever renders on
  // pages layout/theme.liquid did NOT already render #hwCaptureModal on, so
  // the two never compete for the same page.
  (function () {
    var modal = $("#hwWelcome10Modal");
    if (!modal) return;

    var storageKey = "hw_welcome10_state";
    // FIX4 2026-08-15 (PDP-MEASURABLE-SPEC assertions 45/46/48 -- kill the
    // pre-product popup, move capture behind a genuine engagement trigger,
    // make dismissal stick): sessionStorage fallback flag, independent of
    // localStorage. Safari private-mode throws on localStorage.setItem; a
    // dismissal that only lived in localStorage would then silently fail to
    // persist and the popup would re-arm on the very next page. This flag is
    // read on every load BEFORE any trigger is armed (see the early-return
    // block below) -- not just written and forgotten.
    var SESSION_KEY = "hw_welcome10_dismissed_session";
    var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
    var success = modal.querySelector("[data-w10-success='true']");

    function getState() {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || "{}");
      } catch (err) {
        return {};
      }
    }

    function setState(next) {
      try {
        localStorage.setItem(storageKey, JSON.stringify(next));
      } catch (err) {}
    }

    function sessionDismissed() {
      try {
        return sessionStorage.getItem(SESSION_KEY) === "1";
      } catch (err) {
        return false;
      }
    }

    function markSessionDismissed() {
      try {
        sessionStorage.setItem(SESSION_KEY, "1");
      } catch (err) {}
    }

    // FIX4: explicit "dismissal sticks" write -- called from every exit path
    // ("No thanks", the close button, AND a successful submit already hits
    // the permanent `subscribed:true` branch below so it doesn't need this).
    // Two independent stores so a Safari-private localStorage failure still
    // leaves the sessionStorage flag blocking re-arm for the rest of this
    // browser session.
    function persistDismissal() {
      var next = getState();
      next.dismissedUntil = Date.now() + THIRTY_DAYS_MS;
      setState(next);
      markSessionDismissed();
    }

    // Successful native-form post-back (page reloaded with form.posted_successfully?
    // true): show the success state immediately, mark subscribed forever, stop --
    // never re-fires after signup, per spec.
    if (success) {
      setState({ subscribed: true, subscribedAt: Date.now() });
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      modal.querySelectorAll("[data-w10-close]").forEach(function (el) {
        el.addEventListener("click", function () { closeModal(); });
      });
      function closeModal() {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
      }
      return;
    }

    var state = getState();
    if (state.subscribed) return;
    // "Once per visitor, 30-day suppress": the flag is written the MOMENT the
    // popup is shown (see openModal below), not only on an explicit dismiss --
    // so a visitor who just navigates away without touching it still won't be
    // re-shown for 30 days.
    if (state.shownAt && (Date.now() - state.shownAt) < THIRTY_DAYS_MS) return;
    // FIX4: explicit-dismissal 30-day suppress (belt-and-braces alongside
    // shownAt above -- this one is keyed to the actual dismiss action per
    // the FIX4 brief's literal wording, "No thanks / close / submit").
    if (state.dismissedUntil && state.dismissedUntil > Date.now()) return;
    // FIX4: sessionStorage fallback -- READ, not just written. Covers the
    // case where localStorage silently failed to persist a dismissal.
    if (sessionDismissed()) return;

    var popupShown = false;
    var checkingCart = false;
    var isTouch = window.matchMedia("(pointer: coarse)").matches;

    // NOTE (2026-08-12): the Shopify cookie-consent banner element stays in the
    // DOM (just display:none) even after the visitor clicks Accept/Decline -- it
    // is never removed. A presence-only check (document.getElementById(...))
    // would therefore defer this popup forever on every page that ever showed
    // the banner, i.e. almost always. Check actual visibility instead.
    function cookieBannerVisible() {
      var b = document.getElementById("shopify-pc__banner");
      if (!b) return false;
      var style = window.getComputedStyle(b);
      return style.display !== "none" && style.visibility !== "hidden";
    }

    // cart-add-collision guard (2026-08-14, P0 fix -- CART-LEAK-DIAGNOSIS-2026-08-14.md
    // finding A). On desktop the dwell-timer/scroll trigger could fire at the exact
    // moment a visitor clicked "Add to cart", stealing the DOM/focus and the add was
    // lost with item_count staying 0 and zero error shown. Three suppressions, per the
    // fix brief: (a) a real add-to-cart request in flight, (b) a cart that already has
    // an item, (c) a short window after ANY add-to-cart click (covers the moment before
    // the fetch technically starts and any UI settling right after it resolves).
    // PRESERVED VERBATIM by FIX4 (2026-08-15) -- this fix only changes WHEN
    // openModal() gets CALLED (the trigger), never what openModal() itself
    // checks before it is allowed to render.
    var ATC_SUPPRESS_MS = 4000;
    function cartAddInFlightOrRecent() {
      if (cartPending || upsellPending) return true; // (a)
      if (hwLastAtcAt && (Date.now() - hwLastAtcAt) < ATC_SUPPRESS_MS) return true; // (c)
      return false;
    }
    function cartBadgeShowsItems() {
      // Cheap first-pass check from the badge DOM text kept in sync by
      // refreshCartDrawer() -- avoids a network round-trip on the common case.
      var n = Number((cartCountEls[0] && cartCountEls[0].textContent) || "0");
      return n > 0;
    }

    function reallyOpen() {
      popupShown = true;
      setState({ shownAt: Date.now() });
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
    }

    // FIX4: hard floor -- the popup may never render before this wall-clock
    // point, regardless of which engagement trigger fired it (scroll depth,
    // active-time, or exit-intent). Guards "never within the first ~10
    // seconds, and never before the visitor has seen the hero image" -- the
    // PDP's own measured LCP is 451ms (PDP-MEASURABLE-SPEC assertion 44), so
    // by 10s the hero has unambiguously painted on any real connection.
    var PAGE_ENTER_TS = Date.now();
    var MIN_DWELL_MS = 8000; // TIER1 ROW 5: 6-10s band midpoint, was 10000

    function openModal() {
      if (popupShown || checkingCart) return;
      var elapsed = Date.now() - PAGE_ENTER_TS;
      if (elapsed < MIN_DWELL_MS) {
        setTimeout(openModal, MIN_DWELL_MS - elapsed);
        return;
      }
      // (a) + (b) cheap + (c): never interrupt/overwrite a real add-to-cart.
      if (cartAddInFlightOrRecent() || cartBadgeShowsItems()) {
        setTimeout(openModal, 2000);
        return;
      }
      // Don't stack on top of a currently-visible Shopify cookie-consent banner.
      if (cookieBannerVisible()) {
        setTimeout(openModal, 3000);
        return;
      }
      // Final authoritative check straight from Shopify's own cart (2026-08-14): the
      // DOM badge can lag a fetch by a beat, so confirm item_count is really 0 -- via
      // the SAME cart.js source of truth the diagnosis used -- before ever rendering.
      checkingCart = true;
      fetchCartData().then(function (cart) {
        checkingCart = false;
        if (popupShown) return;
        if ((cart.item_count || 0) > 0 || cartAddInFlightOrRecent()) {
          setTimeout(openModal, 2000);
          return;
        }
        reallyOpen();
      }).catch(function () {
        // cart.js unreachable -- don't block genuine-browsing capture forever;
        // the cheap checks above already passed, so fall back to opening.
        checkingCart = false;
        if (!popupShown) reallyOpen();
      });
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      // FIX4: an explicit dismiss (No-thanks / X) sticks for 30 days, on top
      // of the shownAt suppression reallyOpen() already recorded.
      persistDismissal();
    }

    modal.querySelectorAll("[data-w10-close]").forEach(function (el) {
      el.addEventListener("click", function () { closeModal(); });
    });

    // TIER1 ROW 5 (2026-08-15): reconciled with the FIX4 (2026-08-15) engagement
    // gate above -- per the manager brief, replaced the 3-signal gate (scroll
    // depth / active-time / exit-intent) with a single clean 6-10s delay.
    // Evidence: Omnisend, 1.24 billion popup displays (2025, Grade A): 6-10s
    // delay measured as the PEAK opt-in window (2.4%), while exit-intent was
    // the WORST trigger of all (1.8%) and is structurally near-useless at
    // ~80% mobile traffic (no cursor-leaves-viewport signal on a phone).
    // Scroll-depth and 25s-active-time are removed too -- both could fire
    // earlier or later than the 6-10s band the evidence actually supports.
    // openModal() above already enforces the MIN_DWELL_MS floor (now 8000ms,
    // mid-band) via its own elapsed-time self-reschedule, so a single direct
    // call here is sufficient -- every cart-collision / cookie-banner /
    // cart-item guard inside openModal() is UNCHANGED and still applies, as
    // is the dismissal persistence (localStorage + sessionStorage) above.
    // Runs on ALL devices -- mobile stays enabled, per brief.
    openModal();

  })();
})();

/* ================= HW PDP TAP-TO-ZOOM (added 2026-08-15) =================
   Delegated lightbox for product imagery. No markup surgery: images are tagged at
   runtime, one listener on document. Removing this block fully reverts the feature. */
(function () {
  "use strict";
  var SEL = "img.portrait, .box-gallery__main img, .stk-gallery__main img, .pdp__gallery img, .hw-gallery img";
  var MIN = 200; // px - never make icons, logos or badges zoomable

  function hiRes(src) {
    if (!src) return src;
    try {
      var u = new URL(src, location.href);
      if (u.searchParams.has("width")) { u.searchParams.set("width", "1600"); return u.toString(); }
      return src;
    } catch (e) { return src; }
  }

  function best(img) {
    // prefer the largest candidate the browser already knows about
    if (img.currentSrc) return hiRes(img.currentSrc);
    return hiRes(img.getAttribute("src"));
  }

  var box, boxImg;
  function build() {
    if (box) return box;
    box = document.createElement("div");
    box.id = "hwZoom";
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-modal", "true");
    box.setAttribute("aria-label", "Enlarged product image");
    box.innerHTML =
      '<button type="button" class="hw-zoom__close" aria-label="Close enlarged image">&times;</button>' +
      '<img alt="">' +
      '<div class="hw-zoom__hint">Tap anywhere to close</div>';
    document.body.appendChild(box);
    boxImg = box.querySelector("img");
    // ANY click closes - the overlay can never trap anyone
    box.addEventListener("click", close);
    return box;
  }

  var lastFocus = null;
  function open(img) {
    build();
    boxImg.src = best(img);
    boxImg.alt = img.getAttribute("alt") || "Enlarged product image";
    lastFocus = document.activeElement;
    box.classList.add("open");
    document.body.classList.add("hw-zoom-open");
    var btn = box.querySelector(".hw-zoom__close");
    if (btn && btn.focus) btn.focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove("open");
    document.body.classList.remove("hw-zoom-open");
    if (boxImg) boxImg.removeAttribute("src");
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function tag() {
    var imgs = document.querySelectorAll(SEL);
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.closest("a[href]")) continue;          // never hijack a real link
      if (im.classList.contains("hw-zoomable")) continue;
      var r = im.getBoundingClientRect();
      if (r.width && r.width < MIN) continue;        // skip thumbs/icons
      im.classList.add("hw-zoomable");
    }
  }

  document.addEventListener("click", function (e) {
    var img = e.target && e.target.closest && e.target.closest("img.hw-zoomable");
    if (!img) return;
    e.preventDefault();
    open(img);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && box && box.classList.contains("open")) close();
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tag);
  else tag();
  window.addEventListener("load", tag);   // catch lazy-loaded gallery images
})();


/* ================= HW CONSENT PADDING CLEAR (added 2026-08-15) =================
   WHY: HW CONSENT DOCK (assets/extra.css) reserves page-bottom space with
   body:has(#shopify-pc__banner) while the banner is showing, so page content can
   never scroll underneath the fixed banner. But Shopify HIDES the banner node on
   consent (display:none) rather than removing it -- and :has() matches DOM
   PRESENCE, not visibility -- so that reserved space was staying live forever for
   every visitor who ever consented, on every later page, for the rest of their
   session (measured live 2026-08-15: nodeStillInDom true, display "none",
   bodyPaddingBottom still "370px" after clicking Accept).
   FIX: the instant the banner is actually hidden -- by any route (Accept/Decline
   click, Manage-preferences Save, or any other path Shopify's own script takes --
   add a class to <body> the CSS keys off instead of raw node presence. The
   MutationObserver on the banner's own style/class attributes is the ground-truth
   signal: it fires no matter which UI path hid the banner, without this file
   needing to know every button selector. The official Shopify Customer Privacy
   "visitorConsentCollected" event is wired too as a same-tick backstop. Consent
   choices, text, and the Accept/Decline/Manage buttons themselves are untouched --
   this only ever reads the banner's own visibility and writes one class on <body>.
   Removing this block reverts to the pre-2026-08-15 always-on 370px reservation
   (safe fallback, just brings back the dead-space bug). */
(function () {
  "use strict";
  var DECIDED_CLASS = "hw-consent-decided";

  function markDecided() {
    if (document.body && !document.body.classList.contains(DECIDED_CLASS)) {
      document.body.classList.add(DECIDED_CLASS);
    }
  }

  function isHidden(el) {
    if (!el) return true;
    if (el.style && el.style.display === "none") return true;
    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    return !!(cs && cs.display === "none");
  }

  // Official Shopify Customer Privacy API event -- fires once a choice is saved.
  document.addEventListener("visitorConsentCollected", markDecided);

  function watch(banner) {
    if (!banner) return;
    if (isHidden(banner)) { markDecided(); return; }
    if (!("MutationObserver" in window)) return;
    var mo = new MutationObserver(function () {
      if (isHidden(banner)) { markDecided(); mo.disconnect(); }
    });
    mo.observe(banner, { attributes: true, attributeFilter: ["style", "class"] });
  }

  function init() {
    var banner = document.getElementById("shopify-pc__banner");
    if (banner) { watch(banner); return; }
    // Some consent-banner apps inject the node asynchronously -- watch briefly for it.
    if (!("MutationObserver" in window)) return;
    var bodyMo = new MutationObserver(function () {
      var b = document.getElementById("shopify-pc__banner");
      if (b) { watch(b); bodyMo.disconnect(); }
    });
    bodyMo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { bodyMo.disconnect(); }, 15000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
